const relacao_reordenamento_sem_continuidade = {
  path: "/relacao-reordenamento-sem-continuidade",
  redirect: "/teste",
  meta: {
    breadCrumb: "Relação Reordenamento sem Continuidade",
  },
  children: [
    {
      path: "/relacao-reordenamento-sem-continuidade",
      name: "relacao_reordenamento_sem_continuidade",
      component: () =>
        import(
          "@/views/RelacaoReordenamentoSemContinuidade/RelacaoReordenamentoSemContinuidadeHome.vue"
        ),
    },
  ],
};

export { relacao_reordenamento_sem_continuidade };
